<template>
  <div
    class="relative after:border-static-default-low after:absolute after:bottom-0 after:mb-8 after:w-full after:border-b"
  >
    <RevTabs
      class="mx-8"
      data-test="tradein-bo-nav"
      :label="i18n(translations.tabsLabel)"
      role="navigation"
      scrollable
      variant="flexible"
    >
      <RevTabItem
        :active="route.name === ROUTE_NAMES.BUYBACK.WISHLIST"
        class="capitalize"
        :label="i18n(translations.buybackWishlist)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.WISHLIST }"
      />
      <RevTabItem
        :active="
          route.name?.toString().includes(ROUTE_NAMES.BUYBACK.ORDERS.INDEX)
        "
        class="capitalize"
        :label="i18n(translations.buybackOrders)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.ORDERS.ACTIVE }"
      />
      <RevTabItem
        v-if="isOpportunitiesEnabled"
        :active="route.name === ROUTE_NAMES.BUYBACK.OPPORTUNITIES"
        class="capitalize"
        :label="i18n(translations.opportunities)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.OPPORTUNITIES }"
      />
      <RevTabItem
        :active="
          route.name?.toString().includes(ROUTE_NAMES.BUYBACK.OPTIONS.INDEX)
        "
        class="capitalize"
        :label="i18n(translations.options)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.OPTIONS.INDEX }"
      />
      <RevTabItem
        class="capitalize"
        :data-qa="translations.support.id"
        :label="i18n(translations.support)"
        role="tab"
        :to="getExternalLinkList(BCP_47_LOCALES.fr_FR).SUPPORT_CENTER_LINK"
      />
    </RevTabs>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { BCP_47_LOCALES } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import { getExternalLinkList } from '~/constants/externalLinks'
import { ROUTE_NAMES } from '~/constants/routes'

import translations from './TabsBuyback.translations'

const route = useRoute()
const i18n = useI18n()
const { FF_BO_SELLER_TRADE_IN_OPPORTUNITIES } = useRuntimeConfig().public

const isOpportunitiesEnabled = computed(
  () => FF_BO_SELLER_TRADE_IN_OPPORTUNITIES === true,
)
</script>
